import { CompensationStatus, CompensationType, EmployeeStatus, Namespace } from 'enums';

export default {
  [Namespace.Common]: {
    cancel: 'Cancel',
    save: 'Save',
    saveChanges: 'Save changes',
    edit: 'Edit',
    requestFailed: 'Request failed',
    somethingWentWrong: 'Something went wrong. Try again later or tap Report a problem.',
    success: 'Operation completed successfully',
    employeesRequests: 'Employee applications',
    createRequest: 'Create application',
    username: 'Employee name',
    createdOn: 'Created',
    targetPeriod: 'Billing period',
    compensationType: 'Benefit type',
    status: 'Status',
    byEmployee: 'By employee',
    byEmployeeStatus: 'By employee status',
    byPeriod: 'By billing period',
    byType: 'By benefit type',
    byEntity: 'By legal entity',
    byStatus: 'By status',
    clear: 'Clear all',
    autocompletePlaceholder: 'Employee name or username',
    exportRequests: 'Export to Excel',
    exportTooltip: 'The export will be performed based on the filters and sorts applied to the table',
    requestDetails: 'Application details',
    employee: 'Employee',
    legalEntity: 'Legal entity',
    employeeStatus: 'Employee status',
    department: 'Department',
    period: 'Billing period',
    applicationCreatedOn: 'Application creation date',
    employeeComment: 'Employee comment',
    reviewerComment: 'Admin comment',
    billedOn: 'Receipt receiving date',
    originalPaymentSum: 'Application sum',
    requestCurrency: 'Application currency',
    requestToRuleCurrencyRate: 'Conversion rate application/rule',
    ruleToEmployeeCurrencyRate: 'Conversion rate rule/account',
    requestToEmployeeCurrencyRate: 'Conversion rate application/account',
    totalSum: 'Total for accrual',
    employeeCurrency: 'Employee balance currency',
    error: 'Error',
    select: 'Select',
    selectAll: 'Select all',
    all: 'All',
    updateApplications: 'Update applications',
    deleteRequestConfirm: 'Are you sure you want to delete the request?',
    delete: 'Delete',
    deletedRequestNotification: 'Request deleted.',
  },
  [Namespace.Navigation]: {
    navigation: 'Main navigation',
    personal: 'Personal',
    management: 'Management',
    helpSupport: 'Help & support',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    personalArea: 'Account',
    employeeRequests: 'Employee applications',
    archive: 'Archive',
    reports: 'Report',
    news: 'News',
    settings: 'Configuration',
    reportAnIssue: 'Report a problem',
    exit: 'Exit',
    logOut: 'Log out',
  },
  [Namespace.PersonalArea]: {
    myRequests: 'My applications',
    createRequest: 'Create application',
    createdOn: 'Created',
    targetPeriod: 'Billing period',
    compensationType: 'Benefit type',
    status: 'Status',
    requestDetails: 'Application details',
    moreInformation: 'More information about the social package can be found',
    guideInformation: 'User guide can be found',
    here: 'here',
    accessDenied:
      'System works only for employees from the Belarus, Lithuania, Poland, Georgia, and Uzbekistan offices.',
    otherRequests: 'Archive',
  },
  [Namespace.CompensationForm]: {
    compensationType: 'Benefit type',
    consentRequiredError: 'Consent is required',
    consentLabel:
      'I consent to the processing of special categories of personal data for the reimbursement of medical expenses.',
    consentNoteLabel: 'Full explanation:',
    consentNotePurpose: 'Purpose of processing: to administer and provide reimbursement of medical expenses.',
    consentNoteData:
      'The following personal data may be processed under this consent: full name, information about the medical services provided, and other information contained in documents confirming the provision of such medical services.',
    consentNoteLaw:
      'Personal data will be processed in accordance with applicable law and will be retained for a period of 2 years from the date of receipt, after which it will be deleted.',
    consentLabelRobotics:
      "I consent to the processing of my child's personal data for the purpose of reimbursing expenses for robotics courses.",
    consentNotePurposeRobotics:
      'Purpose of processing personal data: to organize and calculate reimbursement for expenses related to robotics courses.',
    consentNoteDataRobotics:
      "Under this consent, the following personal data may be processed: the child's full name, date of birth, and other information contained in the documents provided.",
    consentNoteLawRobotics:
      'The data is processed in accordance with the law and stored until the end of the fiscal year, after which it is deleted.',
    expiredAttachments: 'Attachment deleted due to retention policy (2 years)',
    employeeError: "Enter the employee's name or username",
    compensationTypeError: 'Select benefit type',
    billAmount: 'Receipt amount',
    billAmountPlaceholder: 'Not specified',
    billAmountError: 'Enter check amount',
    paymentAmount: 'Benefit amount',
    paymentAmountPlaceholder: 'Not specified',
    paymentAmountError: 'Specify the benefit amount',
    currency: 'Currency',
    currencyError: 'Select currency',
    billedOn: 'Receipt receiving date',
    billedOnError: 'Select receipt receiving date',
    targetPeriod: 'Billing period',
    targetPeriodError: 'Select billing period',
    employeeComment: 'Employee comment',
    employeeCommentPlaceholder: 'Not specified',
    reviewerComment: 'Admin comment',
    reviewerCommentPlaceholder: 'Not specified',
    attachments: 'Attached files',
    attachFile: 'Attach file',
    attachmentCountHelper: 'Maximum {{count}} attachments',
    attachmentFileSizeHelper: 'Each file must not exceed {{size}} MB',
    attachmentSingleFileSizeError: 'File size cannot exceed {{size}} MB',
    attachmentFileExtensionHelper: 'Allowed types: {{extensions}}',
    attachmentStorageInfo: 'Attachments are retained for 2 years',
    submitCompensation: 'Submit for review',
    attachmentSizeError: 'The total size is more than {{size}} MB',
    attachmentCountError: 'Number of attachments cannot exceed {{count}}',
    attachmentDuplicateError: 'File with the same name and size already attached',
    employee: 'Employee',
    employeePlaceholder: 'Employee name or username',
    attachmentsError: 'Attach a supporting document',
    status: 'Status',
  },
  [Namespace.CompensationStatuses]: {
    [CompensationStatus.Pending]: 'Pending',
    [CompensationStatus.Approved]: 'Approved',
    [CompensationStatus.Rejected]: 'Rejected',
    [CompensationStatus.UpdateRequired]: 'Awaiting update',
    [CompensationStatus.Closed]: 'Closed',
    [CompensationStatus.Failed]: 'Export error',
  },
  [Namespace.EmployeeStatuses]: {
    [EmployeeStatus.Employee]: 'Employee',
    [EmployeeStatus.Evaluation]: 'Evaluation',
    [EmployeeStatus.Registered]: 'Registered',
    [EmployeeStatus.Freelancer]: 'Freelancer',
    [EmployeeStatus.Dismissed]: 'Dismissed',
  },
  [Namespace.CompensationTypes]: {
    [CompensationType.None]: 'Invalid benefit type',
    [CompensationType.Sport]: 'Sports subscription compensation',
    [CompensationType.Medical]: 'Medical expenses compensation',
    [CompensationType.Robotics]: 'Robotics courses',
    [CompensationType.Wedding]: 'Material aid: wedding',
    [CompensationType.Children]: 'Material aid: the birth of a child',
    [CompensationType.FamilyFuneral]: "Material aid: family member's death",
    [CompensationType.Recommendation]: 'Job recommendation',
    [CompensationType.InternetCompensation]: 'Internet compensation',
    [CompensationType.Other]: 'Other benefits',
  },
  [Namespace.CompensationTypesHelpers]: {
    [CompensationType.Sport]:
      '<paragraph>Attach the documents confirming payment: receipt/contract/subscription.</paragraph>' +
      '<paragraph>Subscriptions (including one-time) are accepted for compensation in the first 30 days after their purchase.</paragraph>' +
      '<paragraph>If the subscription is valid for several months, in the "Billing period" field, indicate the month when it was purchased.</paragraph>' +
      '<paragraph>Documents for one-time classes provide in one general application at the end of the month.</paragraph>',
    [CompensationType.Robotics]:
      '<paragraph>Attach the following documents:</paragraph>' +
      '<list><listItem>a receipt or other document confirming payment</listItem>' +
      '<listItem>an agreement with the organization that conducts the courses, indicating: the full name of the child, the period of the classes, the number of hours, and the amount payable</listItem></list>',
    [CompensationType.Wedding]: '<paragraph>Attach the marriage certificate.</paragraph>',
    [CompensationType.Children]: "<paragraph>Attach the child's birth certificate.</paragraph>",
    [CompensationType.FamilyFuneral]:
      '<paragraph>Attach the following documents:</paragraph>' +
      "<list><listItem>documents confirming kinship, including if there was a change of surname (for example birth certificate, parent's marriage certificate, certificate of one's own marriage)</listItem>" +
      "<listItem>relative's death certificate</listItem></list>",
  },
  [Namespace.Settings]: {
    settings: 'Settings',
    permissions: 'Permissions',
    conditionsForSettlements: 'Conditions for calculation',
    taxRates: 'Tax rates',
    userLogin: 'Employee login',
    username: 'Employee name',
    userOrGroupPlaceholder: 'Username or login, AD group',
    adGroup: 'Group Active Directory',
    editAccess: 'Edit permissions',
    hasAdministratorPermission: 'Administration',
    hasRequestCompensationPermission: 'Create applications on behalf of any employee',
    hasManageCompensationsPermission: 'Applications management',
    compensationType: 'Benefit type',
    requiresBill: 'Receipt required',
    fixedAmount: 'Benefit sum is fixed',
    amount: 'Sum $ (if fixed)',
    amountPercent: 'Percent of receipt sum',
    amountLimit: 'Max benefit sum',
    currency: 'Currency',
    taxRateIndividual: 'Tax rate for individuals',
  },
  [Namespace.NotFound]: {
    notFoundTitle: 'Page not found',
    notFoundMessage: 'Perhaps you entered an incorrect address, or the page is outdated and has been removed',
  },
  [Namespace.AccessDenied]: {
    accessDenied: 'Access Denied',
  },
  [Namespace.Reports]: {
    reportGeneration: 'Report generation',
    managingBillingPeriods: 'Billing period management',
    managingStatuses: 'Application statuses management',
    exportInMatrix: 'Export to Matrix',
    compensationType: 'Benefit type',
    closePeriod: 'Close billing period',
    allPeriodsClosed: 'All past billing periods are closed',
    closePeriodModalTitle: 'Closing the billing period',
    exportModalTitle: 'Export to Matrix',
    billingPeriod: 'Billing period',
    confirmClosePeriodText: 'Are you sure you want to close this billing period?',
    confirmExportText: 'Are you sure you want to export the report to Matrix?',
    employee: 'Employee',
    statusRequest: 'Application status',
    statusEmployee: 'Employee status',
    legalEntity: 'Legal entity',
    compensationTypesError: 'Select the benefit type',
    employeesError: 'Choose an employee',
    periodsError: 'Select billing period',
    statusesError: 'Select application status',
    entityError: 'Select legal entity',
    changeStatuses: 'Change application statuses',
    numberOfApplications: 'Number of applications:',
    apply: 'Apply',
    all: 'All',
  },
  [Namespace.StatusActions]: {
    [Namespace.Short]: {
      [CompensationStatus.Approved]: 'Approve',
      [CompensationStatus.Rejected]: 'Reject',
      [CompensationStatus.UpdateRequired]: 'Request an update',
    },
    [Namespace.Long]: {
      [CompensationStatus.Approved]: 'Approve application',
      [CompensationStatus.Rejected]: 'Reject application',
      [CompensationStatus.UpdateRequired]: 'Request an application update',
    },
  },
  [Namespace.News]: {
    news: 'News',
    noPosts: 'There are no new posts yet.',
    actualNews: 'Actual news:',
    previousNews: 'Previous news:',
    viewDetailsLink: 'View details',
  },
};
